/*eslint-disable*/

import React from 'react'
import ServicesBusiness from '../components/services/ServicesBusiness'
import Hero from '../components/services/Hero'
import Navbar from '../components/header/navbar'

const ServicesPage = () => {
  return (
    <div className='relative mb-8 sm:mb-12 md:mb-16'>
      <div className='max-w-7xl mx-auto'>
        <Navbar />
        <Hero />
        <ServicesBusiness />
      </div>
    </div>
  )
}

export default ServicesPage
